import { Upload } from 'antd';
import * as React from 'react';
import { connect } from 'react-redux';
import {
  IconMytourBlue,
  IconMytourDark,
  IconUpload,
} from '../../../../../assets/index';
import {
  actionGetProfile,
  actionHideLoading,
  actionShowLoading,
} from '../../../../../features/system/actions';
import useCoBranding from '../../../../../hooks/useCoBranding';
import MobileBreadCrumb from '../../MobileBreadCrumb/MobileBreadCrumb';
import './MobileCoBranding.scss';
const MobileCoBranding = (props) => {
  const { handleUpload, beforeUpload, uploadButton, imageUrl, loading } =
    useCoBranding({ ...props });
  return (
    <div className='mobile-co-branding'>
      {' '}
      <div className='container-home-branding'>
        <MobileBreadCrumb />
        <div className='title-co-branding'>Co-branding</div>
        <div className='title-sub'>
          Thiết lập Trang Co-branded Landing Page của bạn
        </div>
        <ul className='step-setting'>
          <li>
            Chỉ tải ảnh lên dưới định dạng JPG, JPEG, hoặc PNG với nền trắng
            hoặc không nền
          </li>
          <li>Kích thước ảnh không được quá 5MB</li>
        </ul>

        <div className='upload'>
          <Upload
            name='file'
            showUploadList={false}
            action={handleUpload}
            beforeUpload={beforeUpload}
          >
            <div className='box-upload'>
              <span style={{ display: loading || imageUrl ? 'none' : 'block' }}>
                <IconUpload />
              </span>

              {imageUrl ? (
                <img
                  src={imageUrl}
                  alt='avatar'
                  style={{
                    width: '100%',
                    height: 248,
                    objectFit: 'contain',
                  }}
                />
              ) : (
                uploadButton
              )}
              <div
                className='desc-upload'
                style={{ display: imageUrl ? 'none' : 'block' }}
              >
                Tải ảnh lên dưới định dạng JPG, JPEG, hoặc PNG (kích thước tối
                đa 5MB)
              </div>
            </div>
          </Upload>
          <div className='box-up'>
            <IconMytourDark width='94' />
            <div className='divier-branding' />
            {imageUrl && (
              <img
                src={imageUrl}
                className='img-upload-branding'
                alt='co-branding-img'
              />
            )}
          </div>
          <div className='box-down'>
            <style
              dangerouslySetInnerHTML={{
                __html: `.icon-mytour path {
                        fill: #ff3366
                      }`,
              }}
            ></style>
            <IconMytourBlue width='94' className='icon-mytour' />
            <div className='divier-branding' />
            {imageUrl && (
              <img
                src={imageUrl}
                className='img-upload-branding'
                alt='co-branding-img'
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(
  (state) => ({
    isLoading: state.systemReducer.isLoading,
    profile: state.systemReducer.profile,
  }),
  {
    actionShowLoading,
    actionHideLoading,
    actionGetProfile,
  }
)(MobileCoBranding);
